var map = {
	"./anodot@2x.png": 66,
	"./bringg@2x.png": 67,
	"./colu@2x.png": 68,
	"./fabric@2x.png": 69,
	"./frank@2x.png": 70,
	"./freightos@2x.png": 71,
	"./healthy.io@2x.png": 72,
	"./honeybook@2x.png": 73,
	"./joytunes@2x.png": 74,
	"./lawgeex@2x.png": 75,
	"./lemonade@2x.png": 76,
	"./nexar@2x.png": 77,
	"./platterz@2x.png": 78,
	"./sparkbeyond@2x.png": 79,
	"./tinytap@2x.png": 80,
	"./wework@2x.png": 81,
	"./windward@2x.png": 82,
	"./workiz@2x.png": 83
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;


//////////////////
// WEBPACK FOOTER
// ./src/assets/companies ^\.\/.*@2x\.png$
// module id = 219
// module chunks = 0